import { singleApiReducer } from './single-api-reducer';
import API from '../../API';
import { BdoStatement, OrderType } from 'types';

export const useBdoStatement = (orderType: OrderType.classic | OrderType.loose, id: number) => {
	const reducer = singleApiReducer<BdoStatement | null, number>((id) => API.orders2.order(orderType, id).statement());

	return reducer(id);
};
